import React from 'react';
import { useTranslation } from 'react-i18next';
import 'react-circular-progressbar/dist/styles.css';
import { v4 as uuidv4 } from 'uuid';
import { Col } from 'reactstrap';
import { CircularProgressbar } from 'react-circular-progressbar';

import './styles.scss';
import PrimaryButton from '../../../components/PrimaryButton';
import Card from '../../../components/Card';
import '../../CompanyAdmin/components/DashboardContent/styles.scss';
import BranchAddressIcon from '../../../assets/location_branch.svg';
import CalendarIcon from '../../../assets/calendar.svg';
import InfoIcon from '../../../assets/info-icon.svg';
import StyledLink from '../../../components/StyledLink';
import { formatLink } from '../../../utils/helpers';

const CoursesContent = ({ currentTrainingData, upcomingTrainingData, offerTrainingData, historyTrainingData }) => {
  const { t, i18n } = useTranslation();

  const usedLang = i18n.language;

  return (
    <div className="courses-main-wrapper">
      <Col className="courses-box">
        <p className="courses-col-title">{t('coursesPage.ongoing.title')}</p>
        {currentTrainingData.length < 1 ? (
          <p className="courses-text-light">{t('coursesPage.ongoing.noContent')}</p>
        ) : null}
        <div className="courses-wrapper-cards">
          {currentTrainingData.map(currentTraining => (
            <Card key={uuidv4()} title={currentTraining.title}>
              <div className="d-flex flex-column">
                <div className="row">
                  <div className="col-6 mb-3">
                    <CircularProgressbar
                      className="styled-circular-progressbar"
                      value={currentTraining.progress}
                      text={`${currentTraining.progress}%`}
                    />
                  </div>
                  <div className="col-6 pl-4">
                    <div className="row">
                      <div className="col-8 p-0 font-weight-bold">{t('coursesPage.duration')}</div>
                      <div className="col-4 p-0">{currentTraining.duration}</div>
                    </div>
                    <div className="row">
                      <div className="col-8 p-0 font-weight-bold">{t('coursesPage.remaining')}</div>
                      <div className="col-4 p-0">{currentTraining.remaining}</div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <a href={currentTraining.link} target="_blank" rel="noreferrer noopener">
                    <PrimaryButton className="mt-0">{t('coursesPage.primaryBoxButton')}</PrimaryButton>
                  </a>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </Col>
      <Col className="courses-box">
        <p className="courses-col-title">{t('coursesPage.upComping.title')}</p>
        {upcomingTrainingData.length < 1 ? (
          <p className="courses-text-light">{t('coursesPage.upComping.noContent')}</p>
        ) : null}
        <div className="courses-wrapper-cards">
          {upcomingTrainingData.map(training => (
            <Card key={uuidv4()} title={training.title[`${usedLang}`]}>
              <>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${BranchAddressIcon})`,
                  }}
                >
                  {training.location}
                </li>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${CalendarIcon})`,
                  }}
                >
                  {training.date}
                </li>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${InfoIcon})`,
                  }}
                >
                  <StyledLink href={formatLink(training.link[usedLang])} target="_blank" rel="noopener noreferrer">
                    {t('coursesPage.moreInfoLink')}
                  </StyledLink>
                </li>
              </>
            </Card>
          ))}
        </div>
        <li
          className="text-field-with-icon mt-3"
          style={{ backgroundSize: '22px', backgroundImage: `url(${InfoIcon})` }}
        >
          <p className="courses-text-light">
            {t('coursesPage.linkAdditionalInformation')}{' '}
            <StyledLink href="mailto:feller-ausbildung@feller.ch" variant="light">
              feller-ausbildung@feller.ch
            </StyledLink>
          </p>
        </li>
      </Col>
      <Col className="courses-box">
        <p className="courses-col-title">{t('coursesPage.offered.title')}</p>
        {offerTrainingData.length < 1 ? (
          <p className="courses-text-light">{t('coursesPage.offered.noContent')}</p>
        ) : null}
        <div className="courses-wrapper-cards">
          {offerTrainingData.map(offerCourse => (
            <Card title={offerCourse.title[usedLang]} key={uuidv4()}>
              <>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${InfoIcon})`,
                  }}
                >
                  <StyledLink href={offerCourse.link[usedLang]} target="_blank" rel="noopener noreferrer">
                    {t('coursesPage.moreInfoLink')}
                  </StyledLink>
                </li>
              </>
            </Card>
          ))}
        </div>
      </Col>
      <Col className="courses-box">
        <p className="courses-col-title">{t('coursesPage.finish.title')}</p>
        {historyTrainingData.length < 1 ? (
          <p className="courses-text-light">{t('coursesPage.finish.noContent')}</p>
        ) : null}
        <div className="courses-wrapper-cards">
          {historyTrainingData.map(historyCourse => (
            <Card title={historyCourse.title[usedLang]} key={uuidv4()}>
              <>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${BranchAddressIcon})`,
                  }}
                >
                  {historyCourse.location}
                </li>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${CalendarIcon})`,
                  }}
                >
                  {historyCourse.date}
                </li>
                <li
                  className="text-field-with-icon"
                  style={{
                    backgroundImage: `url(${InfoIcon})`,
                  }}
                >
                  <StyledLink href={formatLink(historyCourse.link[usedLang])} target="_blank" rel="noopener noreferrer">
                    {t('coursesPage.moreInfoLink')}
                  </StyledLink>
                </li>
              </>
            </Card>
          ))}
        </div>
      </Col>
    </div>
  );
};

export default CoursesContent;
